module.exports = __webpack_public_path__ + "static/img/swzyskx.e4daf21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx/swzyskx.png
// module id = 7wfB
// module chunks = 0